<template>
  <div class="body signinbody">
    <div>
      <div class="heightcontainer">
        <div class="d-block d-lg-none">
          <nav
            class="sign-in-navheight navbar navbar-expand-lg navbar-expand-sm navbar-expand-md navbar-expand-xl navbar-fixed-top"
          >
            <div class="col pl-0 d-flex">
              <div class="col-6 mr-auto my-auto ml-md-2">
                <router-link to="/" tag="a">
                  <img src="../assets/Logo.svg" class="MainNewLogo" alt="logo"/>
                </router-link>
              </div>
              <div>
                <span class="fontsize56 proximanova-thin black businesstext">Recruiter</span>
              </div>
            </div>
          </nav>
        </div>
        <div class="">
          <div class="row no-gutters">
            <div class="col-lg-4 p-4 d-none d-lg-block signinleftcard sign-in-background">
              <div class="col-12 pl-4 d-flex flex-column">
                <div class="col-lg-6 pl-0 pr-0 d-flex flex-column mt-lg-5 mb-5">
                  <router-link to="/" tag="a">
                    <img src="../assets/Logo.svg" class="MainNewLogo" alt="logo"/>
                  </router-link>
                  <span class="proximanova-thin fontsize48 black pb-4">Recruiter</span>
                </div>
                <span class="proximanova-bold fontsize32 black mt-5">Join Worknotion</span>
                <span class="proximanova-light fontsize32 black">world’s Best</span>
                <span class="">
                  <span class="proximanova-bold fontsize32 black">Video Professional</span> <span class="ml-2 proximanova-light fontsize32 black">Community</span>
                </span>
              </div>
              <div class="copyright col-lg-12 pb-5 col-sm-12 col-md-12">
                <div class="col-12 pr-4 d-flex flex-column justify-content-between">
                  <div class="d-flex pointer mt-3">
                    <img src="../assets/HelpSignin.svg" alt="help">
                    <span class="proximanova pointer fontsize12 black ml-2 my-auto">Help</span>
                  </div>
                  <div>
                    <span class="proximanova fontsize12 black60"> <span class="fontsize16">&#169;</span> 2022 Worknotion. All rights reserved</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-8 backgroundcolorwhite">
              <div class="col-12 mx-auto mr-0">
                <div class="card-body text-center mb-2 p-0 p-md-4">
                  <div class="d-flex flex-column mt-2">
                    <span class="proximanova-semibold fontsize28 black logintext">Sign In</span>
                    <span class="proximanova fontsize14 black60 text-nowrap mt-3">What do you want to use from worknotion.com</span>
                  </div>
                  <div class="mt-4">
                    <span class="proximanova-semibold fontsize24 black logintext">Please select your purpose</span>
                    <div class="col-12 mt-4 d-flex justify-content-between">
                      <div class="prodcards p-2 pointer borderblack602 borderradius20" @click="navToSignInPages('user')">
                        <div class="d-flex">
                          <div class="d-md-flex justify-content-lg-around mx-auto p-1 col-md-8 col-lg-5">
                            <img src="../assets/signin_job.svg" alt="user signin" width="20" class="my-auto">
                            <span class="fontsize14 black proximanova-semibold text-nowrap mt-1 ml-md-2">Professional</span>
                          </div>
                        </div>
                        <div class="d-none d-md-block borderbottomblack80 mt-2 ml-2 mr-2"></div>
                        <div class="d-none d-md-block fontsize12 black60 mt-2 mb-2 proximanova">
                          Connect, Collaborate, Share interests and Knowledge with diverse people, apply to various jobs and build a strong network globally.
                        </div>
                      </div>
                      <div class="prodcards p-2 pointer borderblack602 borderradius20" @click="navToSignInPages('company')">
                        <div class="d-flex">
                          <div class="d-md-flex justify-content-lg-around mx-auto p-1 col-md-8 col-lg-4">
                            <img src="../assets/signin_company.svg" alt="user signin" width="20" class="my-auto">
                            <span class="fontsize14 black text-nowrap proximanova-semibold mt-1 ml-md-2">Company</span>
                          </div>
                        </div>
                        <div class="d-none d-md-block borderbottomblack80 mt-2 ml-2 mr-2"></div>
                        <div class="d-none d-md-block fontsize12 black60 mt-2 mb-2 proximanova">
                          You will have your business page and profile and can start building value for your brand.
                        </div>
                      </div>
                      <div class="p-2 prodcards pointer borderblue3 borderradius20">
                        <div class="d-flex">
                          <div class="d-md-flex justify-content-lg-around mx-auto p-1 col-md-8 col-lg-4">
                            <img src="../assets/signin_people_blue.svg" alt="user signin" width="20" class="my-auto">
                            <span class="fontsize14 blue text-nowrap proximanova-semibold mt-1 ml-md-2">Recruiter</span>
                          </div>
                          <img src="../assets/blueTickMark.svg" width="15" class="tickmark mt-0 mr-1" alt="selected">
                        </div>
                        <div class="d-none d-md-block borderbottomblack80 mt-2 ml-2 mr-2"></div>
                        <div class="d-none d-md-block fontsize12 black60 mt-2 mb-2 proximanova">
                          Login to recruiter account, post unlimited jobs free of cost and hire candidates that fit for requirement.
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="mt-4">
                    <div v-if="$store.state.showsuccessmessage" class="successfullpassword proximanova">
                      <img src="../assets/Successfull.svg" alt="success"/>
                      {{ successmessage }}
                    </div>
                    <div v-if="$store.state.showupdatedmessage" class="successfullpassword proximanova">
                      <img src="../assets/Successfull.svg" alt="success"/>
                      {{ updatedmessage }}
                    </div>
                    <span class="proximanova fontsize14 red">{{message}}</span>
                  </div>

                  <div class="form mt-2 col-12 mx-auto col-md-8 col-lg-6 mx-auto" v-if="getotpdetails">
                    <div class="row no-gutters mt-4" :class="{'mt-5':!message}">                     
                        <div class="input-group mb-3">
                          <div class="col-12 p-1 d-flex inputborder">
                            <div class="col">
                              <img src="../assets/Email_Phone.svg" alt="email"/>
                            </div>
                            <input type="email"
                              name="Email"
                              v-validate="'required'"
                              @keyup.enter="signindata"
                              class="signininput col-11 proximanova"
                              placeholder="Enter email"
                              v-model="emailId"
                              data-vv-as="Email/Phone"
                              required>
                          </div>
                          
                          <div
                            v-if="errors.has('Email')"
                            class="alert-danger ml-5"
                          >{{ errors.first("Email") }}</div>
                        </div>
                      
                    </div>
                    <div class="row no-gutters mt-2">
                      <div class="input-group mb-3">
                        <div class="col-12 p-1 d-flex inputborder">
                          <div class="col">
                            <img src="../assets/Password_Icon.svg" alt="password"/>
                          </div>
                          <input :type="type"
                            name="password"
                            @keyup.enter="signindata"
                            placeholder="Password"
                            class="signininput col-9 proximanova"
                            v-validate="'required'"
                            v-model="password"
                            data-vv-as="password"
                            required>
                            <div class="col mt-1">
                              <span>
                                <img class="pointer" alt="show" v-if="showpassword" @click="toggleimage" id="viewpassword" src="../assets/ViewPassword_Dissabled.svg"/>
                                <img v-if="!showpassword" alt="hide" class="pointer" @click="toggleimage" id="viewpassword" src="../assets/ViewPassword.svg" />
                              </span>
                            </div>
                        </div>

                        <div
                          v-if="errors.has('password')"
                          class="alert-danger ml-5"
                        >{{ errors.first("password") }}</div>
                      </div>
                    </div>

                    <div class="row ml-3 justify-content-between pr-3 pl-3">
                      <div class="">
                      </div>
                      <div class="">
                        <div class="col">
                          <span class="proximanova fontsize14 blue mr-4 text-nowrap pointer" @click="forgetPassword">Forgot Password?</span>
                        </div>
                      </div>
                    </div>
                    <div class="row no-gutters mt-4">
                      <div class="col-12 mt-4">
                        <button
                          type="button"
                          class="btn btn-light btn-sm w-100 p-2 text-center borderradius20 sign-up-button proximanova blackbackhroundsignin"
                          id="signin"
                          @click="signindata"
                          :disabled="signinbtnclicked"
                        >Sign In <img src="../assets/loginload.svg" v-if="signinbtnclicked" width="27px" alt="loginload"></button>
                      </div>
                    </div>
                    <div class="mx-auto mt-2 pb-5">
                      <span class="proximanova fontsize14 black text-nowrap">Don't have an account ?</span>
                      <span class="proximanova-semibold fontsize14 blue ml-2 text-nowrap pointer" @click="NavToSignUp">Sign Up</span>
                    </div>
                  </div>
                  <!-- Email verificationdetails -->
                  <div v-if="verificationdetails">
                    <div class="col mt-md-4 mt-1">
                      <img src="../assets/OTP_Illustrations.svg" class="mx-auto d-block" alt="img"/>
                    </div>
                    <div class="row no-gutters mt-md-3">
                      <div class="col otptext mr-5 proximanova text-center">{{otpmessage}} {{this.emailId}}</div>
                    </div>
                    <div class="d-flex justify-content-center">
                      <div class="mt-3 ml-2">
                        <div class="col-12 p-1  d-flex inputborder">
                          <input type="text"
                            v-validate=" 'required' "
                            v-model="otp"
                            @keyup="verifyotp()"
                            class="signininput fontsize24 col-12 proximanova text-center"
                            name="OTP"
                            placeholder="Enter OTP"
                            data-vv-as="OTP"
                            maxlength="6">
                        </div>
                        <div
                          v-if="errors.has('OTP')"
                          class="col alert-danger ml-4"
                        >{{ errors.first('OTP') }}</div>
                        <span class="fontsize14 proximanova red">{{message}}</span>
                      </div>
                    </div>

                    <div class="col text-center mt-4 mb-4">
                      <!-- <div @click="getresendotp()">
                        <label class="pointer blue fontsize16 proximanova">Re - send OTP</label>
                      </div> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <APIErrorModal v-if="displayAPIerrorModal" @closeAPIerrorModal="closeAPIerrorModal"></APIErrorModal>
  </div>
</template>
<script>
import htttpsignup from "@/js/http-userdetails.js";
import { bus } from "@/main.js";
import router from '../router';
import {mapMutations} from 'vuex'
import APIErrorModal from '../components/APIerrorpopup.vue'
import wndata from '../js/wn_data.json'
import sessionUtils from "@/js/session-util.js";
export default {
  components: {
    APIErrorModal
  },
  data() {
    return {
      displayAPIerrorModal : false,
      getotpdetails : true,
      verificationdetails : false,
      otpmessage: "Enter OTP sent to your Registered Email ID",
      usersignindata: [],
      emailId: "",
      otp : "",
      password: "",
      message: "",
      whereitwascreated : "",
      recruiterAccountStatus : "ACCEPT",
      businessAccountId: "",
      profileId: null,
      companyName : null,
      error: "",
      loginmessage: "",
      showpassword: true,
      showWelcome: true,
      type: "password",
      signinbtnclicked : false,
      successmessage: "Successfully Registered With Worknotion",
      updatedmessage: "Successfully Password Created",
      currentRoute : '',
      loggedProfileId: null,
      loggeduserId: null
    };
  },
  methods: {
    ...mapMutations([
        'fetchPrivacyPolicyUpdated',
        'fetchTermsConditionsUpdated'
      ]),
    navToSignInPages : function(module) {
      var x = document.createElement('a')
      x.target = '_blank'
      if(module == 'user') {
        x.href = wndata.userWebappSignin
      }else if(module == 'company'){
        x.href = wndata.companyAccountSignIn
      }
      x.click()
    },
    closeAPIerrorModal(){
      this.displayAPIerrorModal = false;
    },
    homepage: function() {
      this.$session.clear();
      this.$session.destroy();

      this.$router.push("/");
    },
    forgetPassword() {
      console.log("forget password clicked")
      localStorage.removeItem('userid')
      localStorage.removeItem('password')
      router.push({
        name : 'forgotpassword'
      })
    },
    setCookies() {
      // console.log("check box clicked")
      let email = this.CryptoJS.AES.encrypt(this.emailId, "seCRET").toString();
      let password = this.CryptoJS.AES.encrypt(this.password, 'seCRET').toString()
      localStorage.setItem("userid", email )
      localStorage.setItem('password', password)
    },
    NavToSignUp() {
      // var x = document.createElement('a')
      // x.target = '_blank'
      // x.href = wndata.companySignUp;
      // x.click()
      router.push({
        name : 'signup'
      })
    },
    getCookes() {
      let storedmail = localStorage.getItem('userid')
      let storedpass = localStorage.getItem('password')
      if(storedmail !== undefined && storedpass !== null &&  storedpass !== undefined && storedpass !== null) {
        let email = this.CryptoJS.AES.decrypt(storedmail, "seCRET").toString(this.CryptoJS.enc.Utf8)
        let password = this.CryptoJS.AES.decrypt(storedpass, 'seCRET').toString(this.CryptoJS.enc.Utf8)
        this.passwordSalt = password
        this.emailId = email;
      }
    },
    signindata() {
      var that = this;
      if (this.emailId != "" && this.password.length >= 8) {
        this.message = ""
      this.signinbtnclicked = true;
      let signuserdata = {
        email : this.CryptoJS.AES.encrypt(this.emailId, "seCRET").toString(),
        passwordSalt : this.CryptoJS.AES.encrypt(this.password, 'seCRET').toString(),
        module:"Recruiter"
        // email: this.emailId,
        // passwordSalt: this.password
      };
      console.log("encrypted data : ", signuserdata)
      htttpsignup
        .post("/businessaccount/signInUser", signuserdata)
        .then(response => {
          this.signinbtnclicked = false;
          if (response.data.apiStatusMessage == "PASSWORD_CORRECT") {
            console.log("signin response : ", response.data)
            this.businessAccountId = response.data.businessAccountId;
            this.email = response.data.email;
            this.profileId = response.data.businessProfileId  ;
            this.companyName =  response.data.companyName;
            this.whereitwascreated = response.data.module;
            this.recruiterAccountStatus = response.data.accountStatus;
            this.$session.set("isLoggedin", true)
            localStorage.setItem("isLoggedin", true)         
            // this.loginSuccessful();
            this.verificationdetails = true;
            this.getotpdetails = false;
          } else if (response.data.errorCode == 1001) {
            this.error = true;
            this.message = response.data.errorMessage;
            //this.error = response.data.apiStatusMessage;
            this.loginFailed();
          } else if (response.data.errorCode == 1002) {
            this.error = true;
            this.message = response.data.errorMessage;
            //this.error = response.data.apiStatusMessage;
            this.loginFailed();
          } else if (response.data.errorCode == 1032) {
            this.error = true;
            this.message = response.data.errorMessage;
            //this.error = response.data.apiStatusMessage;
            this.loginFailed();
          }else if (response.data.errorCode == 1040) {
            this.error = true;
            this.message = response.data.errorMessage;
            //this.error = response.data.apiStatusMessage;
            this.loginFailed();        
          } else if (response.data.errorCode == 1035) {
            this.error = true;
            this.message = response.data.errorMessage;
            //this.error = response.data.apiStatusMessage;
            this.loginFailed();
          }
          else if (response.data.errorCode == 1048) {
            this.error = true;
            this.message = response.data.errorMessage;
            //this.error = response.data.apiStatusMessage;
            this.loginFailed();
          }
        })
        .catch(function(error) {
          that.signinbtnclicked = false;
          that.displayAPIerrorModal = true;
          console.log("Login Failure" + error);
        });
      }else{
        this.message = "Please enter valid login credentials"
      }
    },
    verifyotp() {
      if (this.otp.length === 6) {
        this.emailidverified();
      }
    },
    emailidverified() {
      this.message = "";
      let otpdata = {
        email  :this.CryptoJS.AES.encrypt(this.emailId, "seCRET").toString(),
        otp  :this.CryptoJS.AES.encrypt(this.otp, "seCRET").toString()        
      };

      htttpsignup.put("/businessaccount/verifyotp", otpdata).then(response => {        
        var status = response.data.errorCode;        
        if (response.data.errorCode === 1005) {
          this.loginSuccessful()
        } else if (response.data.errorCode === 1004) {
          this.saved = false;
          this.message = response.data.errorMessage;
        }
      }).catch((e) => {
        this.displayAPIerrorModal = true;
      });
    },
    check() {
      if (this.emailId != "" && this.password.length >= 8) {
        document.getElementById("signin").classList.add("blackbackhroundsignin");
      } else
        document.getElementById("signin").classList.remove("blackbackhroundsignin");
    },

    toggleimage() {
      if (this.showpassword == true) {
        this.type = "text";
        this.showpassword = false;
      } else {
        this.type = "password";
        this.showpassword = true;
      }
    },

    loginFailed() {
      if (this.$session.exists()) {
        //If a session already exists kill the session
        this.$session.clear();
        this.$session.destroy();
      }
    },
    loginSuccessful() {
      // Start the user session
      this.$session.start();
      let selectedJobId = sessionUtils.getSelectedJobId()
      // Set the session variables
      sessionUtils.setBusinessAccountId(this.businessAccountId);
      sessionUtils.setCompanyEmail(this.email);
      sessionUtils.setCompanyProfileId(this.profileId)
      sessionUtils.setRecruiterCompanyName(this.companyName)
      sessionUtils.setmodule(this.whereitwascreated)
      sessionUtils.setRecruiterAccountStatus(this.recruiterAccountStatus)
      // this.getUserByID;
      if(selectedJobId){
        if(this.profileId){
          this.$session.set("selectedJodDetailsFromLogin", false)
          router.push({
            name : 'viewjob', params: { id: selectedJobId}
          })
        }else{
          if(this.whereitwascreated=='Recruiter'){
            this.$router.push('/createprofile')
          }else{
            this.$router.push({name:'postedJobs'});
          }
        }
      }else{
      if(this.profileId && this.profileId !== null && this.profileId != 'undefined') {
        this.$router.push({name:'postedJobs'});
      }else{
        if(this.whereitwascreated=='Recruiter'){
        this.$router.push("/createprofile");
        }else{
          this.$router.push({name:'postedJobs'});
        }
      }
      }
    }
  },

  getUserByID() {
    // httpuserprofile
    //   .get("/userprofile/userbyid/" + this.userId)
    //   .then(response => {
    //     if (this.userId == response.data.userId) {
    //       this.profileId = response.data.profileId;
    //       this.$session.set("profile_id", this.profileId);

    //       console.log(JSON.stringify(response.data));
    //     }
    //   });
  },
  mounted() {    
    this.loggedProfileId = sessionUtils.getCompanyProfileId();
    this.loggeduserId = sessionUtils.getBusinessAccountId();
    // if(this.loggedProfileId !== null && this.loggedProfileId !== undefined) {
    //     // this.$router.go(-1);
    //     this.$session.set("selectElement", 'home')
    //     this.$router.push("/mainHome");
    //   }else if(this.loggedProfileId === null && this.loggedProfileId === undefined && this.loggeduserId !== null && this.loggeduserId !== undefined){
    //     this.$router.push({name:'welcome'});
    //   }
    this.currentRoute = this.$router.currentRoute.name;
    if (this.$store.state.showsuccessmessage) {
      this.showWelcome = false;
      setTimeout(() => {
        this.$store.state.showsuccessmessage = false;
      }, 4000);
    }
    if (this.$store.state.showupdatedmessage) {
      this.showWelcome = false;
      setTimeout(() => {
        this.$store.state.showupdatedmessage = false;
      }, 4000);
    }
    this.getCookes()
    this.fetchTermsConditionsUpdated()
    this.fetchPrivacyPolicyUpdated()
  }
};
</script>
<style scoped>
.signinbody{
  height: 100vh !important;
  background: white !important;;
}
.signinleftcard{
  height: 100vh !important;
}
.copyright{
  position: absolute;
  bottom: 0;
}
.prodcards{
  width: calc(33.33333% - 1.11111rem) !important;
  position: relative;
}
.prodcards:hover{
  border: 2px solid #007AFF !important;
}
.tickmark{
  position: absolute;
  right: 0;
}
.sign-in-color{
  color: #0078FF;
}
.error-login {
  font-size: 12px;
  color: red;
  border: 1px solid darkred;
  padding: 3px;
  background-color: #af5b5e;
  border-radius: 3px;
}
.card {
  /* position: absolute; */
  /* right: 0; */
  /* margin-left: 55%; */
  left: 0;
  top: 0;
  border: 1px solid #dddfe5 !important;
  border-radius: 20px !important;
  background-color: #ffffff !important;
  box-shadow: 0px 60px 60px 0px rgba(0, 23, 56, 0.1);
}
.forgot-password:hover{
  border-bottom: 2px solid #E6784F;
  cursor: pointer;
}
.inputborder{
  border: 1px solid black;
  border-radius: 4px;
}
.signininput{
  border: none;
  padding: 6px;
  flex: auto;
}
input::-moz-focus-inner{
  background-color: none;
}
input:focus{
  outline: none;
}
.signininput:focus{
  outline: none !important;
}
@media screen and (min-width : 770px) and (max-width : 1000px) {
  .card{
    margin:  0 auto;
    margin-top: 14% !important;
    margin-left: 20%;
  }
  .body{
    background-color: white;
  }
}
@media screen and (min-width : 600px) and (max-width : 769px) {
  .card{
    margin:  0 auto;
    margin-top: 18% !important;
    margin-left: 4%;
  }
  .body{
    background-color: white;
  }
  .businesstext{
    font-size: 32px !important;
  }
}
@media screen and (min-width : 760px) and (max-width : 768px) {
  .card{
    margin:  0 auto;
    margin-top: 10% !important;
    margin-left: 16% !important;
  }
}
@media screen and (min-width : 450px) and (max-width : 600px) {
  .body{
    background-color: white;
  }
}
@media screen and (max-width : 600px) {
  .card{
    margin:  0 auto;
    margin-top: 20% !important;
    margin-left: 4%;
  }
  .businesstext{
    font-size: 32px !important;
  }
  .logintext{
    font-size: 24px !important;
  }
  .prodcards{
    width: calc(35.33333% - 1.11111rem) !important;
  }
}
@media screen and (max-width : 380px){
  .prodcards{
    width: calc(38% - 1.11111rem) !important;
  }
}
</style>
